import { PriceType } from "@/types/business/item.type";
import { PriceInterface } from "@/interface/business/item.interface";
import Storage from "@/services/storage";
import { StorageConstants } from "@/enums/storage.enum";

/**
 * Price Class
 * @param {PriceInterface} Price
 */
export default class PriceMoney implements PriceInterface {
  public amount: number;
  public readonly currency: string;
  public readonly local: string;
  public displayPrice: string = "";

  constructor(data: PriceType) {
    const business = Storage.get(StorageConstants.BUSINESS);
    this.currency = business?.currency || "";
    this.local = business?.country || "";
    this.amount = data?.amount || 0;
    this.prepareDisplayPrice(data);
  }
  /**
   * prepare display price and original price to be displayed
   * @param data
   * @private
   */
  private prepareDisplayPrice(data) {
    this.displayPrice = this.itemPrice();
  }
  /**
   * will convert the displayed price to a the format expected from the backend
   */
  public setPriceFromDisplayed(): number {
    let price = Math.floor(parseFloat(this.displayPrice) * 1000);
    this.setAmount(price);
    return price;
  }

  /**
   * Set item price package with currency
   * @private
   * @return {String} PricePackage
   */
  public getPricePackage(): string {
    const currency = this.currency || "";
    return `${this.itemPrice()} ${currency}`;
  }

  /**
   * Get display price value with currency
   * @return {String} DisplayPricePackage
   */
  public getDisplayPrice(): string {
    return Math.floor(this.amount).toLocaleString(this.local, {
      style: "currency",
      currency: this.currency,
    });
  }

  /**
   * Get display price value without currency
   * @return {string} formatted Price
   */
  public getDisplayPriceNumber(): string {
    return this.getDisplayPrice().replace(this.currency, "");
  }

  /**
   * Set item price
   * @param value
   * @public
   * @return {String} Price
   */
  public itemPrice(value = 0): string {
    let price = this.amount || value;
    if (!!price) {
      price = price / 1000;
    }

    return price.toFixed(3);
    //.toOString().replace(/\\B(?=(\\d{3})+(?!\\d))/g, ",");
  }

  /**
   * Set item price
   * @param {number} amount
   * @return {void}
   */
  public setAmount(amount: number): void {
    this.amount = amount;
  }

  /**
   * convert a number to display format
   * @param value
   */
  public convertToDisplayFormat(value): string {
    return parseFloat(value).toFixed(3);
  }
}
